export const ANNIVERSARY_VIEWS = {
  MAIN: 'main',
  RULE: 'rule'
};

export const ANNIVERSARY_PROTECTED_ACTIONS = {
  PARTICIPATE: 'participate',
  AUTHENTICATION: 'authentication',
  LOTTERY: 'lottery',
  LOTTERY_TEN: 'lotteryTen',
  RECORDS: 'records',
  REWARDS: 'rewards',
  TASK_SIGN: 'taskSign',
  TASK_INVITE: 'taskInvite',
  TASK_FOLLOW_WECHAT: 'taskFollowWechat',
  TASK_FOLLOW_WELFARE: 'taskFollowWelfare',
  TASK_FOLLOW_DOUYIN: 'taskFollowDouyin',
  TASK_TIME_LOG: 'taskTimeLog'
};

export const ANNIVERSARY_ERROR_CODES = {
  LOGIN_REQUIRED: -10402,
  ACTIVITY_ENDED: -10154,
  ACCOUNT_NOT_ACTIVATED: -20006
};

export const ANNIVERSARY_BOOKING_URLS = {
  master: 'https://jxsj.xoyo.com/p/m/2026/09/24/new-server/index.html',
  test: 'https://test-zt.xoyo.com/jxsj.xoyo.com/p/m/2026/09/24/new-server/index.html'
};

export const ANNIVERSARY_BOOKING_SWITCH = {
  enabled: false
};

export const ANNIVERSARY_LINKS = {
  officialSiteUrl: 'https://jxsj.xoyo.com/',
  bookingUrl: getAnniversaryBookingUrl()
};

export const ANNIVERSARY_FEEDBACK_MESSAGES = {
  loadingFailed: '页面数据加载失败，请稍后重试',
  activityEnded: '本次活动已结束，感谢你的参与',
  bookingPending: '敬请期待',
  bookingUnavailable: '预约入口暂未开放'
};

/**
 * 预约专题跟随构建环境切换，master 发布走正式，其余环境统一落测试专题。
 *
 * @returns {string} 当前环境对应的预约专题地址。
 */
export function getAnniversaryBookingUrl() {
  return DEPLOY_ENV === 'master' ? ANNIVERSARY_BOOKING_URLS.master : ANNIVERSARY_BOOKING_URLS.test;
}

/**
 * 生成好友点赞客态页完整分享链接，供微信右上角分享和任务 2 短链源链接共用。
 *
 * @param {string} uid get_config 返回的活动分享 uid。
 * @returns {string} 客态页完整链接；uid 为空时返回空字符串。
 */
export function getAnniversaryGuestShareLink(uid) {
  const safeUid = String(uid || '').trim();
  if (!safeUid) {
    return '';
  }
  return `https://${DEPLOY_HTTP_URL}#/guest?uid=${encodeURIComponent(safeUid)}`;
}

export const ANNIVERSARY_INVITE_SHARE_TEXT = '剑侠世界端游十八周年限时 180 连抽，点开周年庆贺帖点赞，共贺周年，为我解锁更多抽奖机会，共贺盛典！';

export const ANNIVERSARY_INVITE_COPY_SUCCESS_TEXT = '链接已复制成功，请分享给好友吧';

export const ANNIVERSARY_GUEST_INVITE_COPY_SUCCESS_TEXT = '您已成功复制链接，请使用微信发送或打开';

export const ANNIVERSARY_PROGRESS_MILESTONES = [
  { count: 50, rewardId: '11' },
  { count: 80, rewardId: '12' },
  { count: 120, rewardId: '13' },
  { count: 150, rewardId: '14' },
  { count: 180, rewardId: '15' }
];

export const ANNIVERSARY_PROGRESS_TRACK = {
  width: 622,
  overLimitWidth: 622,
  milestoneCenters: [37, 174, 309, 446, 583]
};

export const ANNIVERSARY_LOGIN_SESSION_KEY = 'ANNIVERSARY_LOGIN_SOURCE';

export const ANNIVERSARY_TRACK_TITLES = {
  homepage: {
    login: '登录',
    participate: '我要参与',
    logout: '退出'
  },
  navigation: {
    booking: '预约送礼'
  },
  lottery: {
    one: '抽奖一次',
    ten: '抽奖十次'
  },
  auth: {
    login: '登录',
    bindPhone: '前往绑定手机',
    boundPhoneConfirmed: '我已绑定手机',
    activateNow: '立即激活',
    confirmActivation: '确定激活',
    cancel: '取消'
  }
};
